/* -------------------------------------------------------------------------- */
/*                                Dependencies                                */
/* -------------------------------------------------------------------------- */

// Mantine
import {
	ActionIcon,
	BackgroundImage,
	Box,
	Flex,
} from '@mantine/core';

// Styles
import classes from './CardNews.module.css';

// Local ui lib
import { Text } from '../Text';

// Icons
import {
	IconArrowUpRight,
	IconUser,
} from '@tabler/icons-react';
import { upperFirst } from 'lodash';

/* -------------------------------------------------------------------------- */
/*                                  Types                                     */
/* -------------------------------------------------------------------------- */

type CardNewsProps = {
	image?: string;
	author?: string;
	title?: string;
	description?: string;
	onClick?: () => void;
	showAuthor?: boolean;
};

/* -------------------------------------------------------------------------- */
/*                                  Component                                 */
/* -------------------------------------------------------------------------- */
export const CardNews = ({
	image = 'https://res.cloudinary.com/inuk/image/upload/v1750255083/inuk/IGLU/usptbumtdwhypmghqxy3.jpg',
	author = 'Admin',
	title = 'Titre de la news',
	description = "Lorem Ipsum is simply dummy text of the printing and typesetting industry. Lorem Ipsum has been the industry's.",
	onClick,
	showAuthor = true,
}: CardNewsProps) => {
	/* ******************************** RENDERING ******************************* */
	return (
		<Box className={classes.container} onClick={onClick}>
			<Box className={classes.imageWrapper}>
				<BackgroundImage
					src={image}
					radius="sm"
					w={'100%'}
					h={211}
					className={classes.backgroundImage}
				>
					<ActionIcon
						className={classes.centerIcon}
						size="xl"
						variant="filled"
						color="var(--mantine-color-igluSurface-9)"
						aria-label="See details"
						radius="xl"
						tabIndex={-1}
					>
						<IconArrowUpRight color="#727272" size={28} />
					</ActionIcon>
				</BackgroundImage>
				<div className={classes.overlay} />
			</Box>
			<Box
				style={{
					padding: '0px 16px',
				}}
			>
				{showAuthor && (
					<Flex mb={'xs'} align="center">
						<IconUser
							color="var(--mantine-color-igluBlue-9)"
							size={16}
							stroke={1.5}
							aria-hidden="true"
						/>
						<Text
							ml="6px"
							c="var(--mantine-color-igluTextSecondary-9)"
							variant="caption"
							lineClamp={2}
							tt="capitalize"
						>
							{author}
						</Text>
					</Flex>
				)}
				<Text
					c="var(--mantine-color-igluTextPrimary-9)"
					variant="subtitle1"
					lineClamp={1}
					mb={'5px'}
				>
					{upperFirst(title)}
				</Text>
				<Text
					c="var(--mantine-color-igluTextPrimary-9)"
					variant="body2"
					lineClamp={3}
				>
					{upperFirst(description)}
				</Text>
			</Box>
		</Box>
	);
};
